import { Link } from 'react-router-dom'

export default function Logo({ light = false }) {
  return (
    <Link className={`brand ${light ? 'brand--light' : ''}`} to="/" aria-label="Qubispark Technologies home">
      <img className="brand__logo" src="/qubispark-logo.png" alt="Qubispark — Smarter & Sharper" />
    </Link>
  )
}
